import React from "react";
var __jsx = React.createElement;
import { faCalendar, faXmark } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ActionIcon, TextInput } from "@mantine/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { TRIGGER_STYLES } from "./date-field-styles";
import { parseTypedDate } from "./date-field-value";
/** Calendar-opening input: typable for single/datetime, read-only for ranges. */
export function DateFieldTrigger(_ref) {
  var inputRef = _ref.inputRef,
    displayText = _ref.displayText,
    placeholder = _ref.placeholder,
    displayFormat = _ref.displayFormat,
    disabled = _ref.disabled,
    invalid = _ref.invalid,
    readOnly = _ref.readOnly,
    testId = _ref.testId,
    onOpen = _ref.onOpen,
    onClear = _ref.onClear,
    onTypedDate = _ref.onTypedDate;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(displayText),
    text = _useState[0],
    setText = _useState[1];
  var _useState2 = useState(false),
    focused = _useState2[0],
    setFocused = _useState2[1];
  useEffect(function () {
    if (!focused) setText(displayText);
  }, [displayText, focused]);
  var handleChange = function handleChange(event) {
    var next = event.currentTarget.value;
    setText(next);
    onTypedDate(parseTypedDate(next, displayFormat));
  };
  var handleClear = function handleClear() {
    setText("");
    onClear();
  };
  var showClear = Boolean(displayText) && !disabled;
  return /*#__PURE__*/React.createElement(TextInput, {
    ref: inputRef,
    size: "sm",
    autoComplete: "off",
    value: text,
    placeholder: placeholder,
    readOnly: readOnly,
    disabled: disabled,
    error: invalid,
    onChange: handleChange,
    onFocus: function onFocus() {
      setFocused(true);
      onOpen();
    },
    onBlur: function onBlur() {
      return setFocused(false);
    },
    onClick: onOpen,
    icon: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faCalendar,
      className: "h-4 w-4 icon-sds-base-secondary"
    }),
    rightSection: showClear ? /*#__PURE__*/React.createElement(ActionIcon, {
      size: "sm",
      variant: "transparent",
      "aria-label": t("clear", {
        defaultValue: "Clear"
      }),
      onClick: handleClear,
      "data-testid": "".concat(testId, "-clear")
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faXmark,
      className: "h-3.5 w-3.5 icon-sds-base-secondary"
    })) : null,
    styles: TRIGGER_STYLES,
    "data-testid": testId
  });
}